<template>
  <span
  @click="$emit('click')"
   class="text-button" :class="isColourful ? '' : 'text-button-gray'">{{
    text
  }}</span>
</template>
<script>
export default {
  name: 'TextButton',
  props: {
    text: {
      type: String,
      required: true
    },
    isColourful: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style scoped>
.text-button {
  cursor: pointer;
  font-size: 14;
  color: #2fbf79;
}
.text-button-gray {
  color: #aaadb3;
}
</style>
